export const K_VALUES_PRECISION = 2;
